export const formatDate = (dateString: string) => {
  const parts = dateString.split('.');
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

const date = (dateString: string) => {
  const datePart =
    dateString[8] +
    dateString[9] +
    '.' +
    dateString[5] +
    dateString[6] +
    '.' +
    dateString[0] +
    dateString[1] +
    dateString[2] +
    dateString[3];
  const timePart =
    dateString[11] + dateString[12] + ':' + dateString[14] + dateString[15];

  return { datePart, timePart };
};
export const formatDateTime = (dateString: string) => {
  const { datePart, timePart } = date(dateString);
  return `<span style="font-weight:700">${datePart}</span><br><span style="color:#808080">${timePart}</span>`;
};

export const dateTime = (dateString: string) => {
  const { datePart, timePart } = date(dateString);

  return `${datePart} ${timePart}`;
};

const pad = (num: number) => (num < 10 ? '0' + num : num);

export const formatDateRu = (dateString: string | undefined) => {
  if (dateString) {
    const currentDate = new Date(dateString);
    return `${pad(currentDate.getUTCDate())}.${pad(currentDate.getUTCMonth() + 1)}.${currentDate.getUTCFullYear()}`;
  }
};
